module.exports = __webpack_public_path__ + "static/img/teamHonorBg1.50a6e094.png";